<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="d-flex m-3 w-100 justify-content-between">
        <p class="fw-bold">
          پایش و مراقبت دستگاه/ {{$route.params.title}}
        </p>

        <div>

        <button style="transform: translateX(3vw)" class="btn btn-primary btn-submit-1" @click="$router.go(-1)">برگشت</button>

        </div>

      </div>

     <div class="d-flex justify-content-between p-2">
       <div></div>
       <div class="d-flex changer">
         <p>
           اقدام  پشتیبان
         </p>
         <router-link :to="`/problem_analysis/device_monitoring_and_care/by/${$route.params.id}/${$route.params.title}`">
           اقدام پیشران
         </router-link>
       </div>
     </div>




      <Photographer/>







    </div>
  </div>
</template>


<script>
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import splash from "@/components/Splash/Splash.vue";
import SupportMeasures from "@/components/Definition_of_basic_measures/SupportMeasures.vue";
import Photographer from "@/components/device_monitoring_and_care_backup/mother/Photographer.vue";

export default {
  components: {
    Photographer,


    Sidebar,
    splash
  },

}
</script>
<style scoped lang="scss">
.changer{
  background-color: #AFAFAF;
  height: 2vw;
  border-radius: 1vw;
  width: 19vw;
  justify-content: space-evenly;
  &>p:nth-child(1){
    width: 11vw;
    height: 2vw;
    background-color: #3742FA;
    color: #fff;
    transform: translateX(.9vw);
    border-radius: 1vw;
  }
  &>p:nth-child(2){
    margin-left: 1vw;
  }  &>p {
       cursor: pointer;
       font-size: 1vw;
     }
  &>a{
    color: black;
    text-decoration: none;
    margin-left: .9vw;
  }
}
p {
  font-size: 1vw;
}
</style>